
interface EventDayContactEvent {
    eventDayID: number;
    name: string;
    date: string;
    instructor: string;
}

interface EventDayContactCOrg {
    campusOrganizationID: number;
    campusname: string;
    orgname: string;
}

export class MailingEventList {
    dialogCreated: boolean;
    $dialogelement: JQuery;

    constructor() {
        this.dialogCreated = false;
        this.$dialogelement = $("#dialogevt");
        const self = this;

        $(".multiple").on("click", async function () {
            const eventdaycontactid = $(this).data("eventdaycontactid");
            try {
                const data = await self.fetchCampusEvents(eventdaycontactid);
                const items = data.map(item => {
                    const eventname = item.instructor
                        ? `${item.date} - ${item.name} - ${item.instructor}`
                        : `${item.date} - ${item.name}`;
                    return `<li>
                    <a href="EventDetails.aspx?EventDayID=${item.eventDayID}">
                      ${eventname}
                    </a>
                  </li>`;
                });

                self.showItems(items);
            } catch (err) {
                console.error("Failed to load campus events:", err);
            }
        });

        $(".multipleorg").on("click", async function () {
            const eventdaycontactid = $(this).data("eventdaycontactid");
            try {
                const data = await self.fetchOrgEvents(eventdaycontactid);
                const items = data.map(item => `
                      <li>
                        <a href="/campus/CampusOrganizationDetails.aspx?CampusOrgID=${item.campusOrganizationID}">
                          ${item.campusname} – ${item.orgname}
                        </a>
                      </li>`);
                self.showItems(items);
            } catch (err) {
                console.error("Failed to load organization events:", err);
            }
        });
    }

    private async fetchCampusEvents(id: number): Promise<EventDayContactEvent[]> {
        const url = `/event/EventDayContactEvents.ashx?id=${id}`;
        const response = await fetch(url, { cache: "no-store" });
        if (!response.ok) {
            throw new Error(`Error ${response.status} fetching campus events`);
        }
        return response.json();
    }

    private async fetchOrgEvents(id: number): Promise<EventDayContactCOrg[]> {
        const url = `/event/EventDayContactCOrgs.ashx?id=${id}`;
        const response = await fetch(url, { cache: "no-store" });
        if (!response.ok) {
            throw new Error(`Error ${response.status} fetching org events`);
        }
        return response.json();
    }

    private showItems(items: Array<string>) {
        $(".containerevt").html(`<ul>${items.join("")}</ul>`);
        this.$dialogelement.dialog({ width: 720 });
        this.checkdialogcreated();
    }

    checkdialogcreated() {
        const self = this;
        if (!self.dialogCreated) {
            $("html").on("click", function (e) {
                if (
                    self.$dialogelement.dialog("isOpen") &&
                    !$(e.target).is(".ui-dialog, a") &&
                    !$(e.target).closest(".ui-dialog").length
                ) {
                    self.$dialogelement.dialog("close");
                }
            });
            self.dialogCreated = true;
        }
    }
}
